var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74927 3.50002C1.74927 2.85569 2.2716 2.33335 2.91593 2.33335H11.0826C11.7269 2.33335 12.2493 2.85569 12.2493 3.50002V11.0834C12.2493 11.7277 11.7269 12.25 11.0826 12.25H2.91593C2.2716 12.25 1.74927 11.7277 1.74927 11.0834V3.50002ZM11.0826 3.50002H2.91593V11.0834H11.0826V3.50002Z",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24927 1.16669C5.57143 1.16669 5.8326 1.42785 5.8326 1.75002L5.8326 4.08335C5.8326 4.40552 5.57143 4.66669 5.24927 4.66669C4.9271 4.66669 4.66593 4.40552 4.66593 4.08335L4.66594 1.75002C4.66594 1.42785 4.9271 1.16669 5.24927 1.16669Z",
    fill: "#00AEEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74072 5.83335C1.74072 5.51119 2.00189 5.25002 2.32406 5.25002H11.6432C11.9653 5.25002 12.2265 5.51119 12.2265 5.83335C12.2265 6.15552 11.9653 6.41669 11.6432 6.41669H2.32406C2.00189 6.41669 1.74072 6.15552 1.74072 5.83335Z",
    fill: "#00AEEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74927 1.16669C9.07143 1.16669 9.3326 1.42785 9.3326 1.75002L9.3326 4.08335C9.3326 4.40552 9.07143 4.66669 8.74927 4.66669C8.4271 4.66669 8.16593 4.40552 8.16593 4.08335L8.16594 1.75002C8.16594 1.42785 8.4271 1.16669 8.74927 1.16669Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.b4b612eb3a2003e58d2bc3e0b9f4dd1d.svg";
export { ForwardRef as ReactComponent };